import jjv from 'jjv'
import {phoneFormat} from '../core/phonez'

export const REFERENCE_COMPANY_CMD_TYPES = ['CreateClientAccount', 'CreateClientAccountHolding', 'CreateCallCenter']
export const REFERENCE_USER_CMD_TYPES = ['ReferenceExecutive', 'ReferenceClientAccountManager', 'ReferencePatrimonyManager', 'ReferenceCallCenterUser', 'ReferenceCallCenterOperator']
export const UPDATE_COMPANY_CMD_TYPES = ['UpdateClientAccount', 'UpdateClientAccountHolding', 'UpdateCallCenter']
export const BILLING_TYPES = ['SponsoredAccount', 'StandardAccount']

export function createValidator() {
    const validator = jjv()

    validator.addFormat('phone', phoneFormat)
    return validator
}

export class CompanyCriteria {
}

CompanyCriteria.schema = {
    type: 'object',
    properties: {
        fullText: {type: 'string'}
    }
}

export class UserCriteria {
}

UserCriteria.schema = {
    type: 'object',
    properties: {
        active: {type: 'boolean'}
    }
}

export class AgencyCriteria {
}

AgencyCriteria.schema = {
    type: 'object',
    properties: {
        active: {type: 'boolean'}
    }
}

export class ReferenceCompanyCmd {
}

ReferenceCompanyCmd.schema = {
    oneOf: [{
        type: 'object',
        properties: {
            label: {type: 'string'},
            siretNumber: {
                type: ['string', 'null'],
                pattern: '^[a-zA-Z0-9]{14}$'
            },
            callCenterReference: {type: 'string'},
            billingType: {
                type: 'string',
                enum: ['SponsoredAccount']
            },
            commandType: {
                type: 'string',
                enum: ['CreateClientAccount', 'CreateClientAccountHolding']
            }
        },
        required: ['label', 'callCenterReference', 'commandType']
    }, {
        type: 'object',
        properties: {
            label: {type: 'string'},
            siretNumber: {
                type: 'string',
                pattern: '^[a-zA-Z0-9]{14}$'
            },
            callCenterReference: {type: 'string'},
            billingType: {
                type: 'string',
                enum: ['StandardAccount']
            },
            commandType: {
                type: 'string',
                enum: ['CreateClientAccount', 'CreateClientAccountHolding']
            }
        },
        required: ['label', 'callCenterReference', 'siretNumber', 'commandType']
    }, {
        type: 'object',
        properties: {
            label: {type: 'string'},
            siretNumber: {
                type: ['string', 'null'],
                pattern: '^[a-zA-Z0-9]{14}$'
            },
            commandType: {
                type: 'string',
                enum: ['CreateCallCenter']
            }
        },
        required: ['label', 'commandType']
    }]
}

ReferenceCompanyCmd.selectSchema = (cmd) => {
    return ReferenceCompanyCmd.schema.oneOf.find((schema) => {
        const commandType = cmd && cmd.commandType || REFERENCE_COMPANY_CMD_TYPES[0]
        const billingType = cmd && cmd.billingType || BILLING_TYPES[0]

        return schema.properties.commandType.enum.indexOf(commandType) >= 0
            && (!schema.properties.billingType || schema.properties.billingType.enum.indexOf(billingType) >= 0)
    })
}

export class ReferenceAgencyCmd {
}

ReferenceAgencyCmd.schema = {
    type: 'object',
    properties: {
        agency: {
            type: 'object',
            properties: {
                ref: {type: 'string'},
                label: {type: 'string'},
                emails: {
                    type: ['array', 'null'],
                    items: {
                        type: 'string',
                        format: 'email'
                    }
                },
                phones: {
                    type: ['array', 'null'],
                    items: {
                        type: 'string',
                        format: 'phone'
                    }
                },
                fax: {
                    type: ['string', 'null'],
                    format: 'phone'
                },
                address: {
                    type: ['object', 'null'],
                    properties: {
                        number: {type: ['string', 'null']},
                        street: {type: 'string'},
                        zipCode: {type: 'string'},
                        city: {type: 'string'}
                    },
                    required: ['street', 'zipCode', 'city']
                }
            },
            required: ['ref', 'label']
        }
    },
    required: ['agency']
}

export class ReferenceUserCmd {
}

ReferenceUserCmd.schema = {
    oneOf: [{
        type: 'object',
        properties: {
            firstName: {type: 'string'},
            lastName: {type: 'string'},
            login: {
                type: 'string',
                format: 'email'
            },
            job: {type: ['string', 'null']},
            phone: {
                type: ['string', 'null'],
                format: 'phone'
            },
            managedPatrimonies: {
                type: 'array',
                minItems: 1
            },
            commandType: {
                type: 'string',
                enum: ['ReferencePatrimonyManager']
            }
        },
        required: ['firstName', 'lastName', 'login', 'managedPatrimonies', 'commandType']
    }, {
        type: 'object',
        properties: {
            firstName: {type: 'string'},
            lastName: {type: 'string'},
            login: {
                type: 'string',
                format: 'email'
            },
            job: {type: ['string', 'null']},
            phone: {
                type: ['string', 'null'],
                format: 'phone'
            },
            managedAgencies: {
                type: 'array',
                minItems: 1
            },
            commandType: {
                type: 'string',
                enum: ['ReferenceExecutive']
            }
        },
        required: ['firstName', 'lastName', 'login', 'managedAgencies', 'commandType']
    }, {
        type: 'object',
        properties: {
            firstName: {type: 'string'},
            lastName: {type: 'string'},
            login: {
                type: 'string',
                format: 'email'
            },
            job: {type: ['string', 'null']},
            phone: {
                type: ['string', 'null'],
                format: 'phone'
            },
            commandType: {
                type: 'string',
                enum: ['ReferenceCallCenterUser', 'ReferenceCallCenterOperator', 'ReferenceClientAccountManager']
            }
        },
        required: ['firstName', 'lastName', 'login', 'commandType']
    }]
}

ReferenceUserCmd.selectSchema = (cmd) => {
    return ReferenceUserCmd.schema.oneOf.find((schema) => {
        const commandType = cmd && cmd.commandType || REFERENCE_USER_CMD_TYPES[0]
        return schema.properties.commandType.enum.indexOf(commandType) >= 0
    })
}

export class UpdateAgencyCmd {
}

UpdateAgencyCmd.schema = {
    type: 'object',
    properties: {
        agency: {
            type: 'object',
            properties: {
                ref: {type: 'string'},
                label: {type: 'string'},
                emails: {
                    type: ['array', 'null'],
                    items: {
                        type: 'string',
                        format: 'email'
                    }
                },
                phones: {
                    type: ['array', 'null'],
                    items: {
                        type: 'string',
                        format: 'phone'
                    }
                },
                fax: {
                    type: ['string', 'null'],
                    format: 'phone'
                },
                address: {
                    type: ['object', 'null'],
                    properties: {
                        number: {type: ['string', 'null']},
                        street: {type: 'string'},
                        zipCode: {type: 'string'},
                        city: {type: 'string'}
                    },
                    required: ['street', 'zipCode', 'city']
                }
            },
            required: ['ref', 'label']
        }
    },
    required: ['agency']
}

export class UpdateCompanyCmd {
}

UpdateCompanyCmd.schema = {
    type: 'object',
    properties: {
        label: {type: 'string'}
    },
    required: ['label']
}

export class IdentifyCompanyCmd {
}

IdentifyCompanyCmd.schema = {
    type: 'object',
    properties: {
        siretNumber: {
            type: 'string',
            pattern: '^[a-zA-Z0-9]{14}$'
        }
    },
    required: ['siretNumber']
}

export class UpdateUserCmd {
}

UpdateUserCmd.schema = {
    type: 'object',
    properties: {
        firstName: {type: 'string'},
        lastName: {type: 'string'},
        job: {type: ['string', 'null']},
        phone: {
            type: ['string', 'null'],
            format: 'phone'
        }
    },
    required: ['firstName', 'lastName']
}

export class UpdateLoginCmd {
}

UpdateLoginCmd.schema = {
    type: 'object',
    properties: {
        login: {
            type: 'string',
            format: 'email'
        }
    },
    required: ['login']
}

export class DowngradeExecutiveToPatrimonyManagerCmd {
}

DowngradeExecutiveToPatrimonyManagerCmd.schema = {
    type: 'object',
    properties: {
        managedPatrimonies: {
            type: 'array',
            minItems: 1
        }
    },
    required: ['managedPatrimonies']
}

export class CompanyConfigs {
}

CompanyConfigs.schema = {
    type: 'object',
    properties: {
        ticketUidGenerator: {
            type: 'object',
            properties: {
                uidPrefix: {
                    type: 'string',
                    pattern: '^[A-Z]{1,3}$'
                },
                acknowledge: {
                    type: 'boolean',
                    enum: [true]
                }
            },
            required: ['uidPrefix', 'acknowledge']
        }
    }
}

export class UserConfigs {
}

UserConfigs.schema = {
    type: 'object',
    properties: {
        ticketOpenedNotifications: {type: 'boolean'},
        daybookNotifications: {type: 'boolean'},
        simplifiedRequestOpenedNotifications: {type: 'boolean'}
    }
}


// WEBPACK FOOTER //
// ./lib/company/models.js